
import { toRefs, reactive, computed } from 'vue'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { makeSelectorForm } from '@/components/material-selector/index.js'
import { ANALYSIS_TYPE, ANALYSIS_STATUS } from '../../const'
import { secondsToTimestamp } from '@/common/js/utils'
import { getAiStrategys } from '@/api/tools.model'

export const materialSizes = [{ label: '1280*720' }, { label: '720*1280' }]
export const useMaterialSelector = () => {
  const selectorModel = reactive({
    showSelectorModal: false,
    selectorProps: {
      max: 200,
      analysisType: ANALYSIS_TYPE.SEGMENT,
      assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO],
      form: { ...makeSelectorForm(), size: '' }
    },
    selectedAssets: [],
    selectedTopMaterial: null,
    maxSegment: 1000,
    maxSegmentLimitMsg: ''
  })

  const assetIds = computed(() => selectorModel.selectedAssets.map(item => item.image_id))

  const getStrategies = async () => {
    const [globalStrategys] = await getAiStrategys()
    const { promptContent: maxSegment } = globalStrategys.strategies.find(s => s.strategyType === 3 && s.promptName === 'Mix_Cut_Max_Segment')
    if (maxSegment) {
      selectorModel.maxSegment = Number(maxSegment)
    }
  }

  getStrategies()

  function onSegmentMaterialSelect() {
    selectorModel.selectorProps.assetType = MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]
    selectorModel.selectorProps.max = 200
    selectorModel.selectorProps.analysisType = ANALYSIS_TYPE.SEGMENT
    selectorModel.selectorProps.form = { ...makeSelectorForm(), size: '' }
    selectorModel.showSelectorModal = true
  }

  function onTopMaterialSelect() {
    selectorModel.selectorProps.assetType = MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]
    selectorModel.selectorProps.max = 1
    selectorModel.selectorProps.analysisType = ANALYSIS_TYPE.TOP_MATERIAL
    selectorModel.selectorProps.form = { ...makeSelectorForm(), size: '' }
    selectorModel.showSelectorModal = true
  }

  function onTopMaterialSelectBeforeSubmit(selectedRows, callbacks) {
    const { popularAnalysis } = selectedRows[0]

    if (popularAnalysis === ANALYSIS_STATUS.POP_ANALYSIS_COMPLETED) {
      callbacks.done()
    } else {
      callbacks.fail('只能选择已拆解爆款的视频')
    }
  }

  function onSelectorConfirm(assets) {
    let newAssets = []
    if (selectorModel.selectorProps.analysisType === ANALYSIS_TYPE.TOP_MATERIAL) {
      // 切片素材没有id,找到爆款素材
      const topMaterial = assets.find(i => !!i.id)
      // 切片素材checked为true, 找到全部的切片素材
      const topMaterialSlice = assets.filter(i => i.checked)
      selectorModel.selectedTopMaterial = { ...topMaterial }
      newAssets = formatAssets(topMaterialSlice)
    } else {
      newAssets = formatAssets(assets)
    }
    function formatAssets(assets) {
      return assets.map(item => {
        // 把毫秒去掉
        const duration = secondsToTimestamp(item.duration || 0).slice(0, -4)
        return {
          image_id: item.image_id || item.id,
          image_url: item.url || item.image_url,
          cover_url: item.cover_url || item.preview_url,
          info: item.name || item.content_title,
          duration,
          isIntro: false,
          isOutro: false,
          isTransition: false
        }
      })
    }

    const assetsList = []
    for (const asset in newAssets) {
      const item = newAssets[asset]

      if (!assetIds.value.includes(item.image_id)) {
        assetsList.push(item)
      }
    }

    const selectedAssets = selectorModel.selectedAssets.concat(assetsList)
    if (selectedAssets.length > selectorModel.maxSegment) {
      selectorModel.maxSegmentLimitMsg = `最多只能选择${selectorModel.maxSegment}个素材`
      setTimeout(() => {
        selectorModel.maxSegmentLimitMsg = ''
      }, 5500)
    } else {
      selectorModel.maxSegmentLimitMsg = ''
    }
    selectorModel.selectedAssets = selectedAssets
  }
  function onSelectorClose() {
    selectorModel.showSelectorModal = false
  }

  return {
    ...toRefs(selectorModel),
    onSegmentMaterialSelect,
    onTopMaterialSelect,
    onTopMaterialSelectBeforeSubmit,
    onSelectorConfirm,
    onSelectorClose
  }
}

export const useVideoPreview = () => {
  const onVideoEnter = (e) => {
    const video = e.target
    // 确保静音以允许自动播放
    video.muted = true
    // 添加过渡类
    video.classList.add('is-playing')

    const playPromise = video.play()
    if (playPromise !== undefined) {
      playPromise.catch((error) => {
        // 忽略因鼠标快速移出导致的 AbortError
        if (error.name !== 'AbortError') {
          console.error('Video play error:', error)
        }
      })
    }
  }

  const onVideoLeave = (e) => {
    const video = e.target
    video.pause()
    // 重置播放进度（可选，根据需求决定是否保留进度）
    // video.currentTime = 0
    video.classList.remove('is-playing')
  }

  const onVideoError = (e) => {
    console.error('Video load failed:', e)
    e.target.style.display = 'none' // 加载失败隐藏视频
  }

  return {
    onVideoEnter,
    onVideoLeave,
    onVideoError
  }
}
